import {
  GET_USER_ROLE_RELATIONS,
  GET_USER_ROLE_RELATIONS_SUCCESS,
  ADD_USER_ROLE_RELATION,
  ADD_USER_ROLE_RELATION_SUCCESS,
  UPDATE_USER_ROLE_RELATION,
  UPDATE_USER_ROLE_RELATION_SUCCESS,
  DELETE_USER_ROLE_RELATION,
  DELETE_USER_ROLE_RELATION_SUCCESS,
  API_ERROR

} from "./actionTypes"




export const getUserRoleRelation = () => ({
  type: GET_USER_ROLE_RELATIONS,
})

export const getUserRoleRelationSuccess = record => ({
  type: GET_USER_ROLE_RELATIONS_SUCCESS,
  payload: record,
})

export const addUserRoleRelation = record => ({
  type: ADD_USER_ROLE_RELATION,
  payload: record,
})

export const addUserRoleRelationSuccess = record => ({
  type: ADD_USER_ROLE_RELATION_SUCCESS,
  payload: record,
})


export const updateUserRoleRelation = record => ({
  type: UPDATE_USER_ROLE_RELATION,
  payload: record,
})

export const updateUserRoleRelationSuccess = record => ({
  type: UPDATE_USER_ROLE_RELATION_SUCCESS,
  payload: record,
})


export const deleteUserRoleRelation = guid => ({
  type: DELETE_USER_ROLE_RELATION,
  payload: guid,
})

export const deleteUserRoleRelationSuccess = guid => ({
  type: DELETE_USER_ROLE_RELATION_SUCCESS,
  payload: guid,
})

export const userRoleRelationError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

